import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Context from 'frontools/core/Context';
import GamesState from '../core/state/GamesState';
import { Crocroc } from '../crocroc/Crocroc';
import Thumb from 'sources/js/core/module/Thumb';
import YouTube from 'frontools/medias/video/Youtube';
import { YoutubeObject } from 'frontools/medias/video/Youtube';
import AnimManager from "sources/js/core/module/AnimManager";
import Breakpoint from 'frontools/core/Breakpoint';
import ScrollUtils from 'frontools/utils/ScrollUtils';

export class Home extends AbstractDispatcher {

    private _context                : Context                       = Context.getInstance();
    private _video                  : YouTube;

    constructor() {
        super();

        this._updateGamesState();
        
        let config: YoutubeObject = new YoutubeObject();
        config.id = 'nggCqxzjv78';      
        config.responsive = false;
        config.target = document.querySelector('.video_wrapper') as  HTMLElement;
        config.playerSettings.autoplay = false;
        this._video = new YouTube(config);

        // inview animation manager
        if (Breakpoint.isHigherThan('tabletp')) {
            let animManager = new AnimManager(50);
        }

        // Scrolldown button
        let bt = document.querySelector('[data-js="btScrolldown"]');
        if (bt) bt.addEventListener('click', this._onBtScrollClick);

        // thumbs
        let thumbs = document.querySelectorAll('.game.active .thumb');
        for (let i = 0, l = thumbs.length; i < l; i++) {
            let thumb = new Thumb(thumbs[i] as HTMLElement);
        }
    };


    private _onBtScrollClick(e) {
        ScrollUtils.scrollTo({
            target: document.querySelector('.m_games') as HTMLElement,
            speed: .7,
            easing: Expo.easeOut
        })
    };

    
    private _updateGamesState() {
        let data = GamesState.instance.get() as Object,
            games = document.querySelectorAll('.game[data-id]');

        for (let i = 0, l = games.length; i < l; i++) {
            let game = games[i],
                id = game.getAttribute('data-id');

            if (data[id]) {
                let bt = game.querySelector('[data-js="btPlay"]');
                if (bt) {
                    bt.innerHTML = this._context.getValue('strings').replay;
                }
                game.classList.add('online');
            }

            if (!!id) {
                game.classList.add('active');
            }
        }
    };


    private _resize() {

    };


}
